const MS_PER_DAY      = 86400000;
const DAYS_PER_WEEK   = 7;
const MON_FIRST_OFFSET = 6;
const MAX_MONTH_INDEX = 11;
const PAD_THRESHOLD   = 10;
const SESSION_KEY     = 'rhHire';

const MONTHS = [
  'January', 'February', 'March', 'April', 'May', 'June',
  'July', 'August', 'September', 'October', 'November', 'December',
];

const initStepLength = () => {
  const stepEl = document.querySelector('#rh-step-1:not([data-rh-init])');
  if (!stepEl) return;
  stepEl.dataset.rhInit = 'true';

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  let viewYear  = today.getFullYear();
  let viewMonth = today.getMonth();
  let startDate = null;
  let endDate   = null;

  function pad(n) { return n < PAD_THRESHOLD ? '0' + n : '' + n; }

  function toYMD(d) {
    return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate());
  }

  function daysBetween(a, b) {
    return Math.round((b - a) / MS_PER_DAY);
  }

  function formatDateDisplay(d) {
    const day   = d.getDate();
    const month = MONTHS[d.getMonth()];
    const year  = d.getFullYear();
    return day + ' ' + month + ' ' + year;
  }

  function updateDuration() {
    const durationWrap = document.getElementById('rh-duration');
    const durationNum  = document.getElementById('rh-duration-num');
    const nextBtn      = document.getElementById('rh-next-1');
    const nextArrow    = document.getElementById('rh-next-1-arrow');

    if (startDate && endDate) {
      const days = daysBetween(startDate, endDate);
      durationNum.textContent = days;
      durationWrap.style.display = 'flex';
      nextBtn.disabled   = false;
      nextArrow.disabled = false;
    } else {
      durationWrap.style.display = 'none';
      nextBtn.disabled   = true;
      nextArrow.disabled = true;
    }
  }

  function renderCalendar() {
    const label = document.getElementById('rh-cal-month-label');
    label.textContent = MONTHS[viewMonth] + ' ' + viewYear;

    const grid = document.getElementById('rh-cal-grid');
    while (grid.children.length > DAYS_PER_WEEK) {
      grid.removeChild(grid.lastChild);
    }

    const first    = new Date(viewYear, viewMonth, 1);
    const startDow = (first.getDay() + MON_FIRST_OFFSET) % DAYS_PER_WEEK;

    for (let b = 0; b < startDow; b++) {
      const blank = document.createElement('div');
      blank.className = 'rh-cal__day';
      grid.appendChild(blank);
    }

    const daysInMonth = new Date(viewYear, viewMonth + 1, 0).getDate();

    for (let d = 1; d <= daysInMonth; d++) {
      const cell     = document.createElement('div');
      cell.className = 'rh-cal__day';
      cell.textContent = d;

      const thisDate = new Date(viewYear, viewMonth, d);
      thisDate.setHours(0, 0, 0, 0);

      if (thisDate < today) {
        cell.classList.add('is-past');
      } else {
        if (toYMD(thisDate) === toYMD(today)) cell.classList.add('is-today');

        if (startDate && endDate) {
          if (toYMD(thisDate) === toYMD(startDate))           cell.classList.add('is-range-start');
          else if (toYMD(thisDate) === toYMD(endDate))        cell.classList.add('is-range-end');
          else if (thisDate > startDate && thisDate < endDate) cell.classList.add('is-in-range');
        } else if (startDate && toYMD(thisDate) === toYMD(startDate)) {
          cell.classList.add('is-selected');
        }

        cell.dataset.ts = String(thisDate.getTime());
      }

      grid.appendChild(cell);
    }
  }

  function handleDayClick(dt) {
    if (!startDate || (startDate && endDate)) {
      startDate = dt;
      endDate   = null;
    } else {
      if (dt <= startDate) {
        startDate = dt;
        endDate   = null;
      } else {
        endDate = dt;
      }
    }
    updateDuration();
    renderCalendar();
  }

  function goNext() {
    if (!startDate || !endDate) return;
    const days = daysBetween(startDate, endDate);
    const hire = JSON.parse(sessionStorage.getItem(SESSION_KEY) || '{}');
    hire.startDate    = toYMD(startDate);
    hire.endDate      = toYMD(endDate);
    hire.days         = days;
    hire.startDisplay = formatDateDisplay(startDate);
    hire.endDisplay   = formatDateDisplay(endDate);
    sessionStorage.setItem(SESSION_KEY, JSON.stringify(hire));

    const url = new URL(window.location.href);
    url.searchParams.set('step', '2');
    window.location.href = url.toString();
  }

  document.getElementById('rh-cal-grid').addEventListener('click', function (e) {
    const day = e.target.closest('.rh-cal__day[data-ts]');
    if (!day) return;
    handleDayClick(new Date(parseInt(day.dataset.ts)));
  });

  document.getElementById('rh-cal-prev').addEventListener('click', function () {
    viewMonth--;
    if (viewMonth < 0) { viewMonth = MAX_MONTH_INDEX; viewYear--; }
    renderCalendar();
  });

  document.getElementById('rh-cal-next').addEventListener('click', function () {
    viewMonth++;
    if (viewMonth > MAX_MONTH_INDEX) { viewMonth = 0; viewYear++; }
    renderCalendar();
  });

  document.getElementById('rh-next-1').addEventListener('click', goNext);
  document.getElementById('rh-next-1-arrow').addEventListener('click', goNext);

  const saved = JSON.parse(sessionStorage.getItem(SESSION_KEY) || '{}');
  if (saved.startDate) {
    const parts = saved.startDate.split('-');
    startDate = new Date(parseInt(parts[0]), parseInt(parts[1]) - 1, parseInt(parts[2]));
    startDate.setHours(0, 0, 0, 0);
    viewYear  = startDate.getFullYear();
    viewMonth = startDate.getMonth();
  }
  if (saved.endDate) {
    const ep = saved.endDate.split('-');
    endDate = new Date(parseInt(ep[0]), parseInt(ep[1]) - 1, parseInt(ep[2]));
    endDate.setHours(0, 0, 0, 0);
  }

  renderCalendar();
  updateDuration();
};

export default initStepLength;
